import { colors } from '@material-ui/core';

const MuiTableHeader = {
  root: {
    backgroundColor: colors.grey[50]
  }
};
export default MuiTableHeader;